const createTooltip = (el, content, interactive = false) => {
    if (el._tooltipElement) return; // Уже создан, не создавать повторно
    if (!content?.length) return;

    const tooltip = document.createElement('div');
    tooltip.className = 'custom-tooltip';
    tooltip.innerHTML = content;
    tooltip.style.display = 'none';
    document.body.appendChild(tooltip);
    el._tooltipElement = tooltip;

    if (interactive) {
        tooltip.addEventListener('mouseenter', () => {
            clearTimeout(el._hideTimer);
            el._insideTooltip = true;
        });
        tooltip.addEventListener('mouseleave', () => {
            el._insideTooltip = false;
            hideTooltip(el);
        });
    }
};

const showTooltip = (el) => {
    if (!el._tooltipElement) return;
    if (!el._tooltipElement?.innerText?.trim().length) return;

    el._tooltipElement.style.display = 'block';
    el._tooltipElement.style.position = 'absolute';
    el._tooltipElement.style.visibility = 'hidden';
    el._tooltipElement.style.top = '0px';
    el._tooltipElement.style.left = '0px';

    const rect = el.getBoundingClientRect();
    const tooltipRect = el._tooltipElement.getBoundingClientRect();
    const margin = 8;

    const mods = el._tooltipModifiers || {};

    let preferredSide = null;
    let align = 'center';

    if (mods.top) {
        preferredSide = 'top';
    } else if (mods.bottom) {
        preferredSide = 'bottom';
    } else if (mods.left) {
        preferredSide = 'left';
    } else if (mods.right) {
        preferredSide = 'right';
    }

    if (preferredSide === 'top' || preferredSide === 'bottom') {
        if (mods.left) align = 'left';
        else if (mods.right) align = 'right';
    } else if (preferredSide === 'left' || preferredSide === 'right') {
        if (mods.top) align = 'top';
        else if (mods.bottom) align = 'bottom';
    }

    let top = 0;
    let left = 0;

    const tryPosition = (side) => {
        switch (side) {
            case 'top':
                top = rect.top - tooltipRect.height - margin;
                left = align === 'left' ? rect.left : align === 'right' ? rect.right - tooltipRect.width : rect.left + rect.width / 2 - tooltipRect.width / 2;
                break;
            case 'bottom':
                top = rect.bottom + margin;
                left = align === 'left' ? rect.left : align === 'right' ? rect.right - tooltipRect.width : rect.left + rect.width / 2 - tooltipRect.width / 2;
                break;
            case 'left':
                top = rect.top + rect.height / 2 - tooltipRect.height / 2;
                left = rect.left - tooltipRect.width - margin;
                break;
            case 'right':
                top = rect.top + rect.height / 2 - tooltipRect.height / 2;
                left = rect.right + margin;
                break;
        }
    };

    tryPosition(preferredSide);

    const fits = (
        top >= margin &&
        top + tooltipRect.height <= window.innerHeight - margin &&
        left >= margin &&
        left + tooltipRect.width <= window.innerWidth - margin
    );

    if (!fits) {
        const fallbackSides = ['bottom', 'top', 'right', 'left'].filter((s) => s !== preferredSide);
        for (const side of fallbackSides) {
            tryPosition(side);
            if (
                top >= margin &&
                top + tooltipRect.height <= window.innerHeight - margin &&
                left >= margin &&
                left + tooltipRect.width <= window.innerWidth - margin
            ) {
                break;
            }
        }
    }

    top = Math.max(margin, Math.min(top, window.innerHeight - tooltipRect.height - margin));
    left = Math.max(margin, Math.min(left, window.innerWidth - tooltipRect.width - margin));

    el._tooltipElement.style.top = `${top}px`;
    el._tooltipElement.style.left = `${left}px`;
    el._tooltipElement.style.visibility = 'visible';
};

const hideTooltip = (el) => {
    if (!el._tooltipElement) return;

    el._hideTimer = setTimeout(() => {
        if (!el._insideTooltip) {
            el._tooltipElement.style.display = 'none';
        }
    }, 150);
};

const removeTooltip = (el) => {
    if (el._tooltipElement) {
        document.body.removeChild(el._tooltipElement);
        el._tooltipElement = null;
    }
};

export const vTooltip = {
    mounted(el, binding) {
        const content = binding.value;
        const interactive = binding.modifiers.interactive;
        el._tooltipContent = content;
        el._tooltipInteractive = interactive;
        el._tooltipModifiers = binding.modifiers;

        el._mouseenterHandler = () => {
            clearTimeout(el._hideTimer);
            el._insideTooltip = false;

            // Создаём только при первом наведении
            if (!el._tooltipElement) {
                createTooltip(el, el._tooltipContent, el._tooltipInteractive);
            }

            showTooltip(el);
        };

        el._mousedownHandler = () => {
            hideTooltip(el);
        }

        el._mouseleaveHandler = () => {
            if (!interactive) {
                hideTooltip(el);
            } else {
                el._hideTimer = setTimeout(() => {
                    if (!el._insideTooltip) {
                        hideTooltip(el);
                    }
                }, 150);
            }
        };

        el.addEventListener('mouseenter', el._mouseenterHandler);
        el.addEventListener('mouseleave', el._mouseleaveHandler);
        el.addEventListener('mousedown', el._mousedownHandler);
    },

    updated(el, binding) {
        el._tooltipContent = binding.value;
        if (el._tooltipElement) {
            el._tooltipElement.innerHTML = binding.value;
        }
    },

    unmounted(el) {
        el.removeEventListener('mouseenter', el._mouseenterHandler);
        el.removeEventListener('mouseleave', el._mouseleaveHandler);
        el.removeEventListener('mousedown', el._mousedownHandler);
        removeTooltip(el);
    }
};
